import React from 'react';
import PropTypes from 'prop-types';
import { PosContext } from 'store/context';
import { PosReducer } from 'store/reducers/PosReducer';
import { POS_STEP, POS_ORDER_TYPE } from 'constants/Common';

import useReducerWithLogger from './Logger';

function PosProvider({ children }) {
  const initData = {
    showAddNewCustomerModal: false,
    checkout: false,
    status: null,
    step: POS_STEP.POS, // pos - checkout - print
    currentCustomer: {},
    currentOrder: {
      id: null,
      code: '',
      dateOrder: '',
      type: POS_ORDER_TYPE.SALE, // sale - return - exchange
      status: null,
      note: '',
      discountType: 'percent',
      discountPercent: 0,
      discountAmount: 0,
      subtotal: 0,
      grandTotal: 0,
      totalPaid: 0,
      totalReturn: 0,
      soldBy: '',
    },
    currentDoctor: {},
    currentPrescription: {},
    orderItems: [],
    parkedOrders: [],
    showCustomerModal: false,
    showReturnOrderModal: false,
    posLayout: {},
    currentPOSCategory: 0,
    currentPOSFolder: null,
    loading: false,
    loadingFull: false,
    searchResults: { show: false, results: [] },
    isVisibleMedicalForm: false,
    printOrder: {},
  };
  const [PosState, PosDispatch] = useReducerWithLogger(PosReducer, initData);

  return (
    <PosContext.Provider
      value={{
        PosState,
        PosDispatch,
      }}
    >
      {children}
    </PosContext.Provider>
  );
}

PosProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default PosProvider;
